// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1R5oi","noInteraction":"EventWrapper_noInteraction__27GDc"};